import script from "./FAQ-Block.vue?vue&type=script&setup=true&lang=js"
export * from "./FAQ-Block.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__